import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
// import { getDashboardCount } from "../redux/actions/DashboardActions";
import styled from "styled-components";
import { Row, Col, Card, Table, Pagination, Button, Badge, Form } from "react-bootstrap";
import PageTitle from "../../../Components/PageTitle";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { logout } from "../../../redux/actions/AuthActions";
import Preloader from "../../../Components/Preloader";
import { getUserTypePermissionListById, getUserTypePermissionListByUserTypeId, updateUserTypePermissionData } from "../../../redux/actions/UserTypePermissionActions";
import { getMasterUsertypeList } from "../../../redux/actions/MasterActions";
import Select from "react-dropdown-select";


const Dashboard = () => {
  const { t } = useTranslation();
  const tableRef = useRef();
  const [swalProps, setSwalProps] = useState({});
  const [userTypeId, setUserTypeId] = useState(null);
    const [permissionsData, setPermissionsData] = useState([]);
  
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth, loading, errors },
    userTypePermissionReducer: {
      loadingUserTypePermission,
      userTypePermissionByUserIdLists,
      errorsUserTypePermission,
      userTypePermissionLists,
      changedUserTypePermissionStatus,
    },
    masterReducer: {
      loadingMaster,
      masterUsertypeLists,
      masterDesignationList
    },
  } = useSelector((state) => state);

  useEffect(() => {
    dispatch(getMasterUsertypeList(auth?.accessToken));
  }, [auth]);


  useEffect(() => {
    if (errors && Object.keys(errors).length > 0 && errors?.status === 401) {
      dispatch(logout());
    }
  }, [errors, dispatch]);

  useEffect(() => {
    if (userTypeId != null) {
      dispatch(getUserTypePermissionListByUserTypeId(auth?.accessToken, userTypeId));
    }
  }, [userTypeId])

  useEffect(() => {
    dispatch(getUserTypePermissionListByUserTypeId(auth?.accessToken, userTypeId));
  }, [changedUserTypePermissionStatus]);

   const handleSwitchChange = (id, permissionType,menuId, permissions) => {
     
    const newPermissions = {
      ...permissions,
      [permissionType]: !permissions[permissionType],
    };
  
   
    setPermissionsData(prev =>
      prev.map(item =>
        item.id === menuId
          ? {
              ...item,
              permissions: newPermissions,
            }
          : item
      )
    );
      dispatch(updateUserTypePermissionData(auth?.accessToken, id,newPermissions ));
    };
  

  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: t("User Type Permission"), path: "/User-Type-Permission", active: true },
        ]}
        title={t("User Type Permission")}
      />

      <Row>
        <Col>
          <Card>
            <Card.Body>
              <div className="mb-2">
                <Row>
                  <Col lg={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t("User Type")}</Form.Label>
                      <Select
                        options={masterUsertypeLists}
                        // values={masterUsertypeLists?.filter(state => state.id === formData.insurance_id)}
                        name="userTypeId"
                        labelField={"roleName"}
                        valueField={"id"}
                        searchBy={"roleName"}
                        loading={loadingMaster}
                        onChange={(selectedData) => {
                          setUserTypeId(selectedData[0]?.id);
                        }}
                      />

                      {errorsUserTypePermission?.data?.insurance_id && (
                        <div className="invalid-feedback d-block">
                          <p className="text-danger">{errorsUserTypePermission?.data?.insurance_id}</p>
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col lg={9}>
                  </Col>
                </Row>
              </div>

              <div>
                {errorsUserTypePermission?.data?.message && (
                  <div className="alert alert-danger">
                    {errorsUserTypePermission?.data?.message}
                  </div>
                )}
                <div style={{ overflowY: 'auto', maxHeight: '500px', border: "1px solid #dee2e6" }}>
                  <Table ref={tableRef} className="mb-0 table-bordered"
                    size="sm"
                    striped
                    responsive
                    id="table-to-print"
                    style={{ width: "100%", tableLayout: "auto" }}>
                    <thead style={{ position: "sticky", top: 0, backgroundColor: "#f8f9fa", zIndex: 1 }}>
                      <tr>
                        <th>#</th>
                        <th>Menu Name</th>
                        <th>Sub Menu Name</th>
                        <th>View</th>
                        <th>Add</th>
                        <th>Update</th>
                        <th>Delete</th>
                        <th>Filter</th>
                        <th>Print</th>
                        <th>Excel</th>
                      </tr>
                    </thead>
                    <tbody>
                      {userTypePermissionByUserIdLists?.map((item, index) => (
                        <>
                          {/* Main Row for Parent Menu Item */}
                          <tr key={item.id}>
                            <th scope="row">{index + 1}</th>
                            <td>{item?.menuName}</td>
                            <td>{item?.subMenuName ?`${item.subMenuName}` : ""}</td>
                            <td>
                              {item?.permissions && (<>
                                <Form.Check
                                  type="switch"
                                  id={`view-switch-${item?.id}`}
                                  checked={item?.permissions?.view}
                                  onChange={() => handleSwitchChange(item.permissionId,"view",item.id,item.permissions)
                                  }
                                />
                              </>)}
                            </td>
                            <td>
                              {item?.permissions && (<>
                                <Form.Check
                                  type="switch"
                                  id={`add-switch-${item?.id}`}
                                  checked={item?.permissions?.add}
                                onChange={() => handleSwitchChange(item.permissionId,"add",item.id,item.permissions)
                                  }
                                />
                              </>)}

                            </td>
                            <td>
                              {item?.permissions && (<>
                                <Form.Check
                                  type="switch"
                                  disabled={userTypeId === 1 && (item?.id === 23 || item?.id === 24 || item?.id === 17)}
                                  id={`update-switch-${item?.id}`}
                                  checked={item?.permissions.update}
                                  onChange={() => handleSwitchChange(item.permissionId,"update",item.id,item.permissions)
                                  }
                                />
                              </>)}

                            </td>
                            <td>
                              {item?.permissions && (<>
                                <Form.Check
                                  type="switch"
                                  id={`delete-switch-${item?.id}`}
                                  checked={item?.permissions?.delete}
                                   onChange={() => handleSwitchChange(item.permissionId,"delete",item.id,item.permissions)
                                  }
                                />
                              </>)}

                            </td>
                            <td>
                              {item?.permissions && (<>
                                <Form.Check
                                  type="switch"
                                  id={`filter-switch-${item?.id}`}
                                  checked={item?.permissions?.filter}
                                   onChange={() => handleSwitchChange(item.permissionId,"filter",item.id,item.permissions)
                                  }
                                />
                              </>)}

                            </td>
                            <td>
                              {item?.permissions && (<>
                                <Form.Check
                                  type="switch"
                                  id={`print-switch-${item?.id}`}
                                  checked={item?.permissions?.print}
                                    onChange={() => handleSwitchChange(item.permissionId,"print",item.id,item.permissions)
                                  }
                                />
                              </>)}

                            </td>
                            <td>
                              {item?.permissions && (<>
                                <Form.Check
                                  type="switch"
                                  id={`excel-switch-${item?.id}`}
                                  checked={item?.permissions?.excel}
                                    onChange={() => handleSwitchChange(item.permissionId,"excel",item.id,item.permissions)
                                  }
                                />
                              </>)}

                            </td>
                          </tr>

                          {/* Rows for Submenu Items */}
                          {/* {item?.children?.map((child, childIndex) => (
                            <tr key={`${child?.user_type_permissions[0]?.id}-${childIndex}`}>
                              <th scope="row">{`${index + 1}.${childIndex + 1}`}</th>
                              <td></td>
                              <td>{child?.label}</td>
                              <td>
                                {child?.view && (<>
                                  <Form.Check
                                    type="switch"
                                    id={`view-switch-${child?.user_type_permissions[0]?.id}`}
                                    checked={child?.user_type_permissions[0]?.view}
                                    onChange={() => handleSwitchChange(child?.user_type_permissions[0]?.id, "view", null, child?.id)}
                                  />
                                </>)}

                              </td>
                              <td>
                                {child?.add && (<>
                                  <Form.Check
                                    type="switch"
                                    id={`add-switch-${child?.user_type_permissions[0]?.id}`}
                                    checked={child?.user_type_permissions[0]?.add}
                                    onChange={() => handleSwitchChange(child?.user_type_permissions[0]?.id, "add", null, child?.id)}
                                  />
                                </>)}
                              </td>
                              <td>
                                {child?.edit && (<>
                                  <Form.Check
                                    type="switch"
                                    disabled={userTypeId == 1 && (child?.id == 23 || child?.id == 24 || child?.id == 17)}
                                    id={`update-switch-${child?.user_type_permissions[0]?.id}`}
                                    checked={child?.user_type_permissions[0]?.edit}
                                    onChange={() => handleSwitchChange(child?.user_type_permissions[0]?.id, "edit", null, child?.id)}
                                  />
                                </>)}

                              </td>
                              <td>
                                {child?.delete && (<>
                                  <Form.Check
                                    type="switch"
                                    id={`delete-switch-${child?.user_type_permissions[0]?.id}`}
                                    checked={child?.user_type_permissions[0]?.delete}
                                    onChange={() => handleSwitchChange(child?.user_type_permissions[0]?.id, "delete", null, child?.id)}
                                  />
                                </>)}

                              </td>
                              <td>
                                {child?.filter && (<>
                                  <Form.Check
                                    type="switch"
                                    id={`filter-switch-${child?.user_type_permissions[0]?.id}`}
                                    checked={child?.user_type_permissions[0]?.filter}
                                    onChange={() => handleSwitchChange(child?.user_type_permissions[0]?.id, "filter", null, child?.id)}
                                  />
                                </>)}
                              </td>
                              <td>
                                {child?.print && (<>
                                  <Form.Check
                                    type="switch"
                                    id={`print-switch-${child?.user_type_permissions[0]?.id}`}
                                    checked={child?.user_type_permissions[0]?.print}
                                    onChange={() => handleSwitchChange(child?.user_type_permissions[0]?.id, "print", null, child?.id)}
                                  />
                                </>)}

                              </td>
                              <td>
                                {child?.excel && (<>
                                  <Form.Check
                                    type="switch"
                                    id={`excel-switch-${child?.user_type_permissions[0]?.id}`}
                                    checked={child?.user_type_permissions[0]?.excel}
                                    onChange={() => handleSwitchChange(child?.user_type_permissions[0]?.id, "excel", null, child?.id)}
                                  />
                                </>)}

                              </td>
                            </tr>
                          ))} */}
                        </>
                      ))}
                    </tbody>
                  </Table>
                </div>

              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {loadingUserTypePermission && (<Preloader />)}
    </>
  );
};

export default Dashboard;
